import { render, staticRenderFns } from "./ChartBreakdownPie.vue?vue&type=template&id=5ce05c1c&"
import script from "./ChartBreakdownPie.vue?vue&type=script&lang=js&"
export * from "./ChartBreakdownPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports